module.exports = __webpack_public_path__ + "img/finecast.cfa1fd36.png";